(function () {
  function initStickyAddToCart(bar) {
    var targetId = bar.getAttribute('data-target-button-id');
    var stickyButton = bar.querySelector('.sticky-atc__button');
    var buttonsWrapper = null;

    if (targetId) {
      var targetButton = document.getElementById(targetId);
      if (targetButton) {
        buttonsWrapper = targetButton.closest('.product-form__buttons') || targetButton;
      }
    }

    if (!buttonsWrapper || !stickyButton) return;

    stickyButton.addEventListener('click', function () {
      var liveButton = targetId ? document.getElementById(targetId) : null;
      if (liveButton && !liveButton.disabled) {
        liveButton.click();
      }
    });

    if (!('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            bar.classList.remove('sticky-atc--visible');
          } else if (entry.boundingClientRect.top < 0) {
            bar.classList.add('sticky-atc--visible');
          }
        });
      },
      { threshold: 0 }
    );

    observer.observe(buttonsWrapper);
  }

  function init() {
    document.querySelectorAll('[data-sticky-atc]').forEach(initStickyAddToCart);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();